import {combineReducers} from 'redux';

import auth from './auth';
import me from './me';
import register from './app-register';
import applications from './applications';
import landlord from './landlord';
import landlords from './landlords';
import token from './token';
import signup from './signup';
import contractor from './contractor';
import lookup from './lookup';

const rootReducer = combineReducers({
    auth,
    me,
    register,
    applications,
    landlord,
    landlords,
    token,
    signup,
    contractor,
    lookup
});
export default rootReducer;


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/index.js